export default __webpack_public_path__ + "static/media/joyce.9aa65841.jpeg";